export const TB_SHOP_API = {
	orderUrl: 'api/tb_shop/order_url',
	bind: 'api/tb_shop/bind',
	shopList: 'api/tb_shop/shop_list',
}

export const TB_GOOD_API = {
	list: 'api/tb_good/list',
	detail: 'api/tb_good/detail',
	sync: 'api/tb_good/sync',
	syncTrigger: 'api/tb_good/sync_trigger',
	pushStrategySave: 'api/tb_good/push_strategy_save',
	pushConfigGet: 'api/tb_good/push_config_get',
	pushConfigSave: 'api/tb_good/push_config_save',
	syncSkuLogs: 'api/tb_good/sync_sku_logs',
	delete: 'api/tb_good/delete',
	restore: 'api/tb_good/restore',
	manualChannelMatch: 'api/tb_good/manual_channel_match',
	manualSave: 'api/tb_good/manual_save',
	fixedPriceChannelMatch: 'api/tb_good/fixed_price_channel_match',
	safetyStockPriceChannelMatch: 'api/tb_good/safety_stock_price_channel_match',
	skuOuterIdGenerate: 'api/tb_good/sku_outer_id_generate',
	skuOuterIdSave: 'api/tb_good/sku_outer_id_save',
	batchSetSaleStatus: 'api/tb_good/batch_set_sale_status',
	productUpdate: 'api/tb_good/product_update',
}

export const TB_AFTER_SALE_API = {
	list: 'api/tb_after_sale/list',
	download: 'api/tb_after_sale/download',
}

export const TB_ORDER_API = {
	list: 'api/tb_order/list',
	match: 'api/tb_order/match',
	matchSave: 'api/tb_order/match_save',
	updateStylenumber: 'api/tb_order/update_stylenumber',
	fillReceiver: 'api/tb_order/fill_receiver',
	makeOrder: 'api/tb_order/make_order',
	rematch: 'api/tb_order/rematch',
	sync: 'api/tb_order/sync',
}

export const TB_ORDER_WAIT_SEND = 'WAIT_SELLER_SEND_GOODS'
export const TB_ORDER_CLOSED_STATUS = ['TRADE_CLOSED', 'TRADE_CLOSED_BY_TAOBAO']

export const TB_ORDER_STATUS_OPTIONS = [
	{ value: 'WAIT_BUYER_PAY', label: '待付款' },
	{ value: 'WAIT_SELLER_SEND_GOODS', label: '待发货' },
	{ value: 'SELLER_CONSIGNED_PART', label: '部分发货' },
	{ value: 'WAIT_BUYER_CONFIRM_GOODS', label: '已发货' },
	{ value: 'TRADE_BUYER_SIGNED', label: '已签收' },
	{ value: 'TRADE_FINISHED', label: '交易成功' },
	{ value: 'TRADE_CLOSED', label: '交易关闭' },
]

export const TB_REFUND_STATUS_OPTIONS = [
	{ value: 'NO_REFUND', label: '无退款' },
	{ value: 'WAIT_SELLER_AGREE', label: '买家申请退款' },
	{ value: 'SELLER_REFUSE_BUYER', label: '卖家拒绝退款' },
	{ value: 'WAIT_BUYER_RETURN_GOODS', label: '买家退货' },
	{ value: 'WAIT_SELLER_CONFIRM_GOODS', label: '卖家收货' },
	{ value: 'REFUND_SUCCESS', label: '退款成功' },
	{ value: 'CLOSED', label: '退款关闭' },
]

export const TB_MATCH_STATUS_OPTIONS = [
	{ value: 1, label: '可下单' },
	{ value: 2, label: '不可下单' },
	{ value: 3, label: '下单成功' },
	{ value: 4, label: '下单失败' },
]

export const TB_PLATFORM_ORDER_STATUS_OPTIONS = [
	{ value: 1, label: '已付款' },
	{ value: 2, label: '已取消' },
	{ value: 3, label: '配货中' },
	{ value: 4, label: '已发货' },
	{ value: 9, label: '其他' },
]

export const TB_SECURITY_OPTIONS = [
	{ value: 1, label: '未设置' },
	{ value: 2, label: '撕防伪' },
	{ value: 3, label: '不撕防伪' },
]

export function formatTbOrderGood(row) {
	if (!row) {
		return '-'
	}
	const style = row.style_number != null ? String(row.style_number) : ''
	const size = row.size != null ? String(row.size) : ''
	const num = row.num != null && row.num !== '' ? String(row.num) : ''
	let price = ''
	if (row.match_price != null && row.match_price !== '') {
		const n = Number(row.match_price)
		price = !isNaN(n) ? n.toFixed(2) : String(row.match_price)
	}
	return style + '|' + size + '|' + num + '|' + price
}

export function hasTbFilledValue(value) {
	return value !== '' && value != null
}

export function formatTbProfitText(row) {
	if (!hasTbFilledValue(row && row.profit)) {
		return '-'
	}
	const n = Number(row.profit)
	if (!isNaN(n)) {
		return n.toFixed(2)
	}
	return String(row.profit)
}

export function isTbProfitNegative(row) {
	if (!hasTbFilledValue(row && row.profit)) {
		return false
	}
	const n = Number(row.profit)
	return !isNaN(n) && n < 0
}

export function formatTbReturnRateText(row) {
	if (!row) {
		return '-'
	}
	if (!hasTbFilledValue(row.free_return_rate) && !hasTbFilledValue(row.exceed_rate_deduct)) {
		return '-'
	}
	const rate = hasTbFilledValue(row.free_return_rate) ? row.free_return_rate : '-'
	const deduct = hasTbFilledValue(row.exceed_rate_deduct) ? row.exceed_rate_deduct : '-'
	return rate + '%+' + deduct + '%'
}

export function formatTbMatchSecurity(row) {
	if (row && row.match_security_str) {
		return String(row.match_security_str)
	}
	const n = Number(row && row.match_security)
	if (n === 1) {
		return '未设置'
	}
	if (n === 2) {
		return '撕防伪'
	}
	if (n === 3) {
		return '不撕防伪'
	}
	return '-'
}

export function canMakeTbOrder(row) {
	return Number(row && row.match_status) === 1 && String(row.order_status || '') === TB_ORDER_WAIT_SEND
}

export function canRematchTbOrder(row) {
	return Number(row && row.match_status) === 4
}

export function isTbOrderClosed(row) {
	const status = String((row && row.order_status) || '')
	if (TB_ORDER_CLOSED_STATUS.indexOf(status) !== -1) {
		return true
	}
	return String((row && row.order_status_str) || '') === '交易关闭'
}

export function canEditTbOrderOps(row) {
	if (!row || isTbOrderClosed(row)) {
		return false
	}
	return Number(row.match_status) !== 3
}

export function isTbReceiverMasked(row) {
	if (!row) {
		return false
	}
	const fields = [row.receiver_name, row.receiver_mobile, row.receiver_address]
	for (let i = 0; i < fields.length; i++) {
		const text = fields[i] == null ? '' : String(fields[i])
		if (!text || text.indexOf('*') !== -1) {
			return true
		}
	}
	return false
}

export function needTbFillReceiver(row) {
	return canEditTbOrderOps(row) && isTbReceiverMasked(row)
}

export function formatTbStyleNumberSize(row) {
	if (!row) {
		return ''
	}
	const style = row.style_number != null && String(row.style_number) !== '' ? String(row.style_number) : ''
	const size = row.size != null && String(row.size) !== '' ? String(row.size) : ''
	if (style && size) {
		return style + '|' + size
	}
	return style || size
}

export function joinTbOrderIds(rows) {
	const ids = []
	;(rows || []).forEach(function(row) {
		if (row && row.id != null && row.id !== '') {
			ids.push(row.id)
		}
	})
	return ids.join(',')
}

export function tbMatchStatusTagType(row) {
	const n = Number(row && row.match_status)
	if (n === 1) {
		return 'success'
	}
	if (n === 2) {
		return 'danger'
	}
	if (n === 3) {
		return 'primary'
	}
	if (n === 4) {
		return 'warning'
	}
	return 'info'
}

export function tbPlatformOrderStatusTagType(row) {
	if (!row || row.platform_order_status === '' || row.platform_order_status == null) {
		return 'info'
	}
	const n = Number(row.platform_order_status)
	if (n === 4) {
		return 'success'
	}
	if (n === 1 || n === 3) {
		return 'warning'
	}
	if (n === 2) {
		return 'danger'
	}
	return 'info'
}

export function tbRefundStatusTagType(row) {
	const value = String((row && row.refund_status) || '').toUpperCase()
	if (value === 'REFUND_SUCCESS' || value === 'SUCCESS') {
		return 'danger'
	}
	if (value === 'NO_REFUND' || value === 'CLOSED' || !value) {
		return 'info'
	}
	return 'warning'
}

export function isTbOrderAutoCancel(row) {
	return Number(row && row.is_auto_cancel) === 1
}

export const SKU_OUTER_ID_RULE_LABELS = {
	system_default: '竖杠（平台默认）',
	'|': '竖杠',
	'/': '斜杠',
	'-': '减号',
	none: '无分隔符',
}

export function formatSkuOuterIdRuleLabel(rule) {
	return SKU_OUTER_ID_RULE_LABELS[rule] || '平台默认'
}

export function hasParsedSizeKey(value) {
	return value != null && String(value).trim() !== ''
}

export const TB_GOOD_SYNC_TIMEOUT = 120000
export const TB_GOOD_SALE_STATUS_TIMEOUT = 60000

export const TB_ZERO_STOCK_ERROR = 'IC_FORBIDDEN_QUANTITY_ZERO_ERROR'
export const TB_ZERO_STOCK_HINT = '该 SKU 未绑定渠道或聚合库存为 0，请先绑定渠道后再同步'

export const CHANNEL_STATUS = {
	bound: { label: '已绑定', type: 'success' },
	expired: { label: '已过期', type: 'warning' },
	unbound: { label: '待接入', type: 'info' },
}

export function getChannelMeta(status) {
	return CHANNEL_STATUS[status] || CHANNEL_STATUS.unbound
}

export function hasExpiredChannel(row) {
	const channels = (row && row.channels) || {}
	return channels.goods === 'expired' || channels.order === 'expired' || channels.listing === 'expired'
}

export function getRequestErrorMessage(err, fallback) {
	if (err && err.data && (err.data.message || err.data.msg)) {
		return err.data.message || err.data.msg
	}
	const res = err && err.response
	const data = res && res.data
	if (data && (data.message || data.msg)) {
		return data.message || data.msg
	}
	if (res && res.status === 404) {
		return '淘宝接口暂未发布到当前环境，请确认后端已部署'
	}
	if (res && res.status) {
		return fallback + '（HTTP ' + res.status + '）'
	}
	return fallback
}

export function isRequestTimeout(err) {
	if (!err) {
		return false
	}
	if (err.code === 'ECONNABORTED') {
		return true
	}
	const message = String(err.message || '')
	return /timeout/i.test(message)
}

export function formatTbGoodSyncStats(data) {
	if (!data || typeof data !== 'object') {
		return '同步完成'
	}
	const labels = {
		created: '新增',
		added: '新增',
		updated: '更新',
		deleted: '删除',
		failed: '失败',
		skipped: '跳过',
		total: '合计',
		goods_count: '商品',
		sku_count: 'SKU',
	}
	const parts = []
	Object.keys(labels).forEach((key) => {
		if (data[key] == null || data[key] === '') {
			return
		}
		parts.push(labels[key] + data[key])
	})
	if (parts.length) {
		return '同步完成：' + parts.join('，')
	}
	return data.message || data.msg || '同步完成'
}

export function stringifySkuId(value) {
	if (value == null || value === '') {
		return ''
	}
	return String(value)
}

export function isTbGoodDeleted(row) {
	return Number(row && row.is_deleted) === 1 || Number(row && row.goods_status) === 4
}

export function formatApproveStatus(status) {
	if (status === 'onsale') {
		return '在售'
	}
	if (status === 'instock' || status === 'inventory') {
		return '仓库中'
	}
	if (status == null || status === '') {
		return '-'
	}
	return String(status)
}

export function formatTbGoodsStatus(row) {
	if (!row) {
		return '-'
	}
	if (row.goods_status_label) {
		return row.goods_status_label
	}
	if (isTbGoodDeleted(row)) {
		return '已删除'
	}
	const status = Number(row.goods_status)
	if (status === 1 || Number(row.is_onsale) === 1 || row.approve_status === 'onsale') {
		return '上架'
	}
	if (status === 3 || row.down_reason === 'soldout') {
		return '售罄'
	}
	if (status === 2 || Number(row.is_onsale) === 0 || row.approve_status === 'instock') {
		return '下架'
	}
	return '-'
}

export function tbGoodsStatusClass(row) {
	if (isTbGoodDeleted(row)) {
		return 'is-deleted'
	}
	const text = formatTbGoodsStatus(row)
	if (text === '在售' || text === '上架') {
		return 'is-on'
	}
	if (text === '售罄') {
		return 'is-soldout'
	}
	if (text === '仓库中' || text === '下架') {
		return 'is-off'
	}
	return 'is-unknown'
}

export function formatGoodsSyncStatus(value) {
	if (value == null || value === '') {
		return '-'
	}
	if (typeof value === 'string') {
		const text = value.toUpperCase()
		if (text === 'DONE' || text === 'SUCCESS') {
			return '同步成功'
		}
		if (text === 'FAILED' || text === 'FAIL') {
			return '同步失败'
		}
		if (text === 'PARTIAL') {
			return '同步部分'
		}
		if (text === 'PENDING' || text === 'NONE' || text === 'UNSYNC') {
			return '未同步'
		}
		return value
	}
	const num = Number(value)
	if (num === 2) {
		return '成功'
	}
	if (num === 3) {
		return '失败'
	}
	if (num === 4) {
		return '部分成功'
	}
	if (num === 0) {
		return '未同步'
	}
	return String(value)
}

export function syncStatusTagType(value) {
	const text = formatGoodsSyncStatus(value)
	if (text === '部分成功' || text === '同步部分' || text === '同步中') {
		return 'warning'
	}
	if (text === '成功' || text === '同步成功') {
		return 'success'
	}
	if (text === '失败' || text === '同步失败') {
		return 'danger'
	}
	return 'info'
}

export function formatSkuLogState(state) {
	const num = Number(state)
	if (num === 2) {
		return '成功'
	}
	if (num === 3) {
		return '失败'
	}
	return formatGoodsSyncStatus(state) === '-' ? '-' : formatGoodsSyncStatus(state)
}

export function formatPriceFromFen(value) {
	if (value == null || value === '') {
		return '-'
	}
	const yuan = Number(value) / 100
	if (isNaN(yuan)) {
		return '-'
	}
	return yuan.toFixed(2)
}

export function formatZeroStockError(message) {
	const text = String(message || '')
	if (!text) {
		return ''
	}
	if (text.indexOf(TB_ZERO_STOCK_ERROR) !== -1 || text.indexOf('上架的数量必须大于0') !== -1) {
		return text + '。' + TB_ZERO_STOCK_HINT
	}
	return text
}

export function isTbFixedPriceRule(syncRule) {
	return !!(syncRule && String(syncRule).indexOf('fixed_price_channel') === 0)
}

export function isTbSafetyStockRule(syncRule) {
	return !!(syncRule && String(syncRule).indexOf('safety_stock_price') === 0)
}

export function isTbShopPushStrategy(syncRule) {
	return syncRule === 'fixed_price_channel_shop' || syncRule === 'safety_stock_price_shop'
}

export function isTbProductPushStrategy(syncRule) {
	return syncRule === 'fixed_price_channel_product' || syncRule === 'safety_stock_price_product'
}

export function resolvePushConfigType(syncRule) {
	if (syncRule === 'none') {
		return 'none'
	}
	if (syncRule === 'manual') {
		return 'manual'
	}
	if (isTbFixedPriceRule(syncRule)) {
		return 'fixed_price_channel'
	}
	if (isTbSafetyStockRule(syncRule)) {
		return 'safety_stock_price'
	}
	return 'manual'
}

export function resolveTbShopRulePath(syncRule) {
	if (syncRule === 'fixed_price_channel_shop') {
		return '/StoreConfig/taobao/detailed/fixedPriceChannelRule'
	}
	if (syncRule === 'safety_stock_price_shop') {
		return '/StoreConfig/taobao/detailed/safetyStockPriceRule'
	}
	return ''
}

export function resolveTbChannelMatchApi(syncRule) {
	if (isTbFixedPriceRule(syncRule)) {
		return TB_GOOD_API.fixedPriceChannelMatch
	}
	if (isTbSafetyStockRule(syncRule)) {
		return TB_GOOD_API.safetyStockPriceChannelMatch
	}
	return TB_GOOD_API.manualChannelMatch
}

export function buildTbChannelMatchPayload(productId, syncRule, extra) {
	const payload = {
		retail_shop_product_id: Number(productId),
		config_source: syncRule,
		show_unmatched: 1,
	}
	if (isTbFixedPriceRule(syncRule)) {
		payload.show_blacklisted = 0
		payload.filter_zero_stock_channels = 1
	} else {
		payload.show_blacklisted = 1
	}
	const opts = extra || {}
	if (isTbFixedPriceRule(syncRule) && Array.isArray(opts.sku_prices) && opts.sku_prices.length) {
		payload.sku_prices = opts.sku_prices
	}
	if (isTbProductPushStrategy(syncRule)) {
		if (opts.push_config) {
			payload.push_config = opts.push_config
		}
		if (isTbSafetyStockRule(syncRule)) {
			if (opts.sku_stocks) {
				payload.sku_stocks = opts.sku_stocks
			}
			if (opts.safety_discount != null && opts.safety_discount !== '') {
				payload.safety_discount = opts.safety_discount
			}
		}
	}
	return payload
}



// WEBPACK FOOTER //
// ./src/constants/taobaoShop.js